import loadable from '@loadable/component';

export const ActionsCentersLoadable = loadable(() => import('./ActionsCenters'), {
  resolveComponent: module => module.ActionsCenters,
  ssr: false,
});
